export interface ICancelSchedule {
  cancelUser: string;
  reschedule: boolean;
  division: number;
  country: string;
  dealer: number;
  advisor: number;
  scheduleHour: number;
  scheduleDate: string;
}
